var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2193_58",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.8147e-06H22.5V22H0.5V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2193_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6549 16.9297H12.345M15.735 16.9297H17.4251M5.58462 16.9297H7.27471M10.6549 11.8594H12.345M15.735 11.8594H17.4251M5.58462 11.8594H7.27471M1.35938 7.61978H21.6504M16.5801 5.08462V0.859379M6.42969 5.08462V0.859379M4.74935 21.1406H18.2604C20.1326 21.1406 21.6504 19.6229 21.6504 17.7506V5.93949C21.6504 4.06725 20.1326 2.54947 18.2604 2.54947H4.74935C2.87712 2.54947 1.35938 4.06725 1.35938 5.93949V17.7506C1.35938 19.6229 2.87712 21.1406 4.74935 21.1406Z",
    stroke: "#481B9D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.134811ef75399b8fb58a371b0aaacd72.svg";
export { ForwardRef as ReactComponent };